
//Add Value to the end of an array
import * as environmentHelper from "./environmentHelper";

export function immutablePush(arr, newEntry){

    return [ ...arr, newEntry ];
}

//Remove the last element of an array,
export function immutablePop(arr){
    return arr.slice(0, -1);
}

//Removes the nth value of an array
export function immutableShift(arr){
    return arr.slice(1);
}

//Adds value to the beginning of an array
export function immutableUnshift(arr, newEntry){
    return [ newEntry, ...arr ];
}

//Sort the array
export function immutableSort(arr, compareFunction) {
    return [ ...arr ].sort(compareFunction);
}

//Revers the order of an array
export function immutableReverse(arr) {
    return [ ...arr ].reverse();
}

//Delete x amount of values from and array at the nth index, can also replace delected values with new one at nth index
export function immutableSplice(arr, start, deleteCount, ...items) {
    return [ ...arr.slice(0, start), ...items, ...arr.slice(start + deleteCount) ];
}

export function immutableDelete (arr, index) {
    return arr.slice(0,index).concat(arr.slice(index+1));
}

export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randomiseArray(arr){
    for (let i = arr.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [arr[i - 1], arr[j]] = [arr[j], arr[i - 1]];
    }
    return arr;
}

export function isEven(n){
    return n % 2 == 0;
}

export function createGuid()
{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}

export function getFileExtention(filename){
    return filename.split('.').pop().toLowerCase();
}

export function getRangePercentage(min, max, current) {
    return ((current - (min)) / (max - (min)) * 100);
}

export function cssPropertyValueSupported(prop, value) {
	let env = environmentHelper.getEnvironment();
    let d = document.createElement('div');
    d.style[prop] = value;
    return d.style[prop] === value && env.userAgent.indexOf("Edge") === -1;
}

export function getAllTabbableElements(parentEl){
    return parentEl.querySelectorAll('button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])');
}

export function toTitleCase(str){
    return str.toLowerCase().replace(/^(.)|\s(.)/g, ($1) => $1.toUpperCase());
}


/** WEBPACK FOOTER **
 ** ./src/helpers/dataHelper.js
 **/